export default class AdParams {
  constructor(adData) {
    this.dl_pos = adData.dl_pos;
    this.dl_win = adData.dl_win;
    this.dl_cid = adData.dl_cid;
    this.dl_crid = adData.dl_crid;
    this.dl_adom = adData.dl_adom;
    this.dl_dsp = adData.dl_dsp;
    this.prc_net_rs_g = adData.prc_net_rs_g;
    this.err_cod = adData.err_cod;
    this.err_tp = adData.err_tp;
    this.rq_tp = 'AD';
  }

  setDeliveryPos(deliveryPos) {
    this.dl_pos = deliveryPos;
    return this;
  }

  setDeliveryWinner(deliveryWinner) {
    this.dl_win = deliveryWinner;
    return this;
  }

  setDeliveryCampaingId(campaingId) {
    this.dl_cid = campaingId;
    return this;
  }

  setDeliveryCreativeId(creativeID) {
    this.dl_crid = creativeID;
    return this;
  }

  setDeliveryAdDomain(adDomain) {
    this.dl_adom = adDomain;
    return this;
  }

  setDeliveryDSP(dsp) {
    this.dl_dsp = dsp;
    return this;
  }

  setPriceNetworkResponse(priceNetworkResponse) {
    this.prc_net_rs_g = priceNetworkResponse;
    return this;
  }

  // para video
  setDeliveryVideoDisplay(dlVidDis) {
    this.dl_vid_dis = dlVidDis;
    return this;
  }

  setDeliveryVideoPos(pos) {
    this.dl_vid_pos = pos;
    // this.dl_vid_pos = 'pre';
    return this;
  }

  // lo que tarda la red en responder
  setDeliveryTime(deliveryTime) {
    this.dl_tm = deliveryTime;
    return this;
  }

  setElapsedTimeGlobal(elapsedTimeGlobal) {
    this.el_tm_glb = elapsedTimeGlobal;
    return this;
  }

  setDeliveryVideoDuration(duration) {
    this.dl_vid_dur = duration && !Number.isNaN(duration) ? duration : 0;
    return this;
  }

  setVastLoops(loops) {
    this.dl_vst_lps = loops;
    return this;
  }

  setErrorCode(errorCode) {
    this.err_cod = errorCode;
    return this;
  }

  setErrorType(erroType) {
    this.err_tp = erroType;
    return this;
  }

  build() {
    return {
      dl_pos: this.dl_pos,
      dl_win: this.dl_win,
      dl_cid: this.dl_cid,
      dl_crid: this.dl_crid,
      dl_adom: this.dl_adom,
      dl_dsp: this.dl_dsp,
      prc_net_rs_g: this.prc_net_rs_g,
      rq_tp: this.rq_tp,
      dl_vid_dis: this.dl_vid_dis,
      dl_vid_pos: this.dl_vid_pos,
      dl_tm: this.dl_tm,
      el_tm_glb: this.el_tm_glb,
      dl_vid_dur: this.dl_vid_dur,
      dl_vst_lps: this.dl_vst_lps,
      err_cod: this.err_cod,
      err_tp: this.err_tp,
    };
  }
}
